function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
  fill: "#e9e9e0"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#d9d7ca",
  d: "M37.5.151V12h11.849z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
  fill: "#f29c1f"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.379 48.105L21.936 53h-1.9l-1.6-3.801h-.137L16.576 53h-1.9l2.557-4.895-2.721-5.182h1.873l1.777 4.102h.137l1.928-4.102H22.1l-2.721 5.182zM31.998 42.924h1.668V53h-1.668v-6.932l-2.256 5.605h-1.449l-2.27-5.605V53h-1.668V42.924h1.668l2.994 6.891 2.981-6.891zM37.863 42.924v8.832h4.635V53h-6.303V42.924h1.668z"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 24a.999.999 0 01-.707-1.707l6-6a.999.999 0 111.414 1.414l-6 6A.997.997 0 0115.5 24z",
  fill: "#f29c1f"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5 30a.997.997 0 01-.707-.293l-6-6a.999.999 0 111.414-1.414l6 6A.999.999 0 0121.5 30zM33.5 30a.999.999 0 01-.707-1.707l6-6a.999.999 0 111.414 1.414l-6 6A.997.997 0 0133.5 30z",
  fill: "#f29c1f"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M39.5 24a.997.997 0 01-.707-.293l-6-6a.999.999 0 111.414-1.414l6 6A.999.999 0 0139.5 24zM24.5 32a1 1 0 01-.943-1.334l6-17a1 1 0 111.886.666l-6 17A1 1 0 0124.5 32z",
  fill: "#f29c1f"
});

var SvgXml = function SvgXml(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default SvgXml;